<template>
    <slot v-if="isUserEligibleToViewContent"></slot>
</template>

<script setup>
import { computed } from 'vue';

import { useGetters, useState } from '~coreModules/core/js/composables/vuexHelpers';

import { userIsEligibleToViewContent } from '~modules/contentful/js/contentful-utils';

import { BOX_MODULE_NAME } from '~modules/box/js/box-store';
import { PROFILE_MODULE_NAME } from '~modules/profile/js/profile-store';

const props = defineProps({
    eligibility: {
        type: Object,
        default: null,
    },
});

const { loggedIn } = useGetters(['loggedIn']);
const { effectiveSubscriptionStatus } = useGetters(PROFILE_MODULE_NAME, ['effectiveSubscriptionStatus']);
const { hasRecentOrder } = useGetters(BOX_MODULE_NAME, ['hasRecentOrder']);

const { boxOrderStatus } = useState(BOX_MODULE_NAME, {
    boxOrderStatus: state => state.boxOrderStatus,
});

const isUserEligibleToViewContent = computed(() => userIsEligibleToViewContent({
    eligibilityRules: props.eligibility,
    isLoggedIn: loggedIn.value,
    boxOrderStatus: boxOrderStatus.value,
    subscriptionStatus: effectiveSubscriptionStatus.value,
    hasRecentOrder: hasRecentOrder.value,
}));
</script>
